import { render, staticRenderFns } from "./Promocode.vue?vue&type=template&id=5e3e2698&scoped=true"
import script from "./Promocode.vue?vue&type=script&lang=js"
export * from "./Promocode.vue?vue&type=script&lang=js"
import style0 from "./Promocode.vue?vue&type=style&index=0&id=5e3e2698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e2698",
  null
  
)

export default component.exports